module.exports = __webpack_public_path__ + "img/4.73d8dc37.png";